const API_BASE = process.env.REACT_APP_API_URL || '';

export async function fetchDashboard() {
  const res = await fetch(`${API_BASE}/api/dashboard`);
  if (!res.ok) throw new Error('Failed to fetch dashboard');
  return res.json();
}

export async function fetchIssues(filters = {}) {
  const params = new URLSearchParams();
  if (filters.project) params.set('project', filters.project);
  if (filters.status) params.set('status', filters.status);
  if (filters.priority) params.set('priority', filters.priority);
  if (filters.minAge) params.set('min_age', filters.minAge);
  
  const res = await fetch(`${API_BASE}/api/issues?${params}`);
  if (!res.ok) throw new Error('Failed to fetch issues');
  return res.json();
}

export async function fetchCriticality() {
  const res = await fetch(`${API_BASE}/api/criticality`);
  if (!res.ok) throw new Error('Failed to fetch criticality');
  return res.json();
}

export async function triggerSync() {
  const res = await fetch(`${API_BASE}/api/sync`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to trigger sync');
  return res.json();
}

export async function fetchSyncStatus() {
  const res = await fetch(`${API_BASE}/api/sync/status`);
  if (!res.ok) throw new Error('Failed to fetch sync status');
  return res.json();
}

export async function fetchProjects() {
  const res = await fetch(`${API_BASE}/api/projects`);
  if (!res.ok) throw new Error('Failed to fetch projects');
  return res.json();
}

export async function updateProjectVisibility(projectKey, isVisible) {
  const res = await fetch(`${API_BASE}/api/projects/${encodeURIComponent(projectKey)}/visibility`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ is_visible: isVisible }),
  });

  if (!res.ok) throw new Error('Failed to update project visibility');
  return res.json();
}
